export default {
  data () {
    return {
      countdownCurrent: 0
    }
  },
  methods: {
    countdownReset (initValue, callback, tickCallback) {
      this.countdownCurrent = initValue
      this.countdownTimerLoop(callback, tickCallback)
    },
    countdownTimerLoop (callback, tickCallback) {
      this.countdownCurrent--
      tickCallback && tickCallback()
      this.countdownCurrent > 0 && setTimeout(
        () => this.countdownTimerLoop(callback, tickCallback), 1000
      )
      this.countdownCurrent === 0 && callback && callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/bind/mixins/CountdownMixin.js